import type {FC} from 'react';
import {CAREER_ADVISER_INTERVIEW_TRAINING} from '../../../../../../config/constants/routes';
import {CommonLink} from '../../../../../../shared/components/CommonLink';
import {getAIGradient} from '../../../../../reportAnalytics/usecase/getAIGradient';

/**
 * 面接練習へのリンクコンポーネント
 * 選考管理ページから面接トレーニングページへ遷移するためのリンク
 * @param companyId - 企業ID（指定時はクエリパラメータとして付与）
 */
export const InterviewTrainingLink: FC<{
  companyId?: number;
}> = ({companyId}) => {
  const href = companyId
    ? `${CAREER_ADVISER_INTERVIEW_TRAINING}?companyId=${companyId}`
    : CAREER_ADVISER_INTERVIEW_TRAINING;

  return (
    <CommonLink
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-sm font-bold text-white border-[2px] rounded-full px-12 py-8 whitespace-nowrap hover:opacity-60 hover:cursor-pointer"
      style={{
        background: getAIGradient(),
        borderColor: getAIGradient(),
      }}
    >
      AI面接対策
    </CommonLink>
  );
};
